<template>
	<div class='supervisorPages doctorPage'>
		<div>
			<el-row :gutter="10" class="statisticsNum">
				<el-col :span="8">
					<div class="bgBox">
						<svg-icon class='titleSvg grey' icon-class='icon-home-core'></svg-icon>
						<div class="inlin nowrap">
							<span>被质控影像中心数</span>
							<span class="number">
								<numberGrow v-if="reportCountList.TotalHospitalCount>0&&destroy.flag" :value="reportCountList.TotalHospitalCount"></numberGrow>
								<span v-if="reportCountList.TotalHospitalCount==0">0</span> 家
							</span>
						</div>
					</div>
				</el-col>
				<el-col :span="8">
					<div class="bgBox">
						<svg-icon class='titleSvg grey' icon-class='icon-home-people'></svg-icon>
						<div class="inlin nowrap">
							<span>被质控医技人数</span>
							<span class="number">
								<numberGrow v-if="reportCountList.TotalDoctorCount>0&&destroy.flag" :value="reportCountList.TotalDoctorCount"></numberGrow>
								<span v-if="reportCountList.TotalDoctorCount==0">0</span> 人
							</span>
						</div>
					</div>
				</el-col>
				<el-col :span="8">
					<div class="bgBox">
						<svg-icon class='titleSvg grey' icon-class='icon-home-total'></svg-icon>
						<div class="inlin nowrap">
							<span>质控报告总数</span>
							<span class="number">
								<numberGrow v-if="reportCountList.TotalReportCount>0&&destroy.flag" :value="reportCountList.TotalReportCount"></numberGrow>
								<span v-if="reportCountList.TotalReportCount==0">0</span> 份
							</span>
						</div>
					</div>
				</el-col>
			</el-row>
		</div>
		<el-row class="showEcharts" :gutter="20">
			<el-col :span="18" class="supervisorLeft">
				<div class="sliderDate">
					<slider-screening />
				</div>
				<organization-echart ref="originzation" />
				<doctor-echart />
			</el-col>
			<el-col :span="6" class="supervisorRight">
				<supervisor-right />
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import organizationEchart from '../../components/supervisor/organizationEchart'
	import doctorEchart from '../../components/supervisor/doctorEchart'
	import supervisorRight from '../../components/supervisor/supervisorRight'
	import doctorReport from '../../components/doctorReport'
	import doctorGrade from '../../components/doctorGrade'
	import sliderScreening from '../../components/supervisor/sliderScreening'
	import numberGrow from '../../components/tool/numberGrow'

	// import { mapState, mapActions, mapMutations} from 'vuex'

	export default {
		data() {
			return {

			}
		},
		components: {
			organizationEchart,
			doctorEchart,
			supervisorRight,
			doctorReport,
			doctorGrade,
			sliderScreening,
			numberGrow
		},
		computed: {
			...Vuex.mapState('supervisor', ['destroy', 'reportCountList', 'setDate', 'slider', 'HospitalAVGScoreBtn', 'trigger',
				'HospitalAVGScoreBtn','DoctorsAvgScoreArr','HospitalAVGScoreArr'
			]),
			reportCountLists() {
				return this.reportCountList.TotalHospitalCount;
			}
		},
		mounted() {
			this.$nextTick(function() {
				this.DoctorsAvgScoreArr.pageIndex = 1;
				this.HospitalAVGScoreArr.type = 2;
				this.setIsSubmint(true)
				this.setisSubmintflag(true)
			})
		},
		methods: {
			...Vuex.mapMutations('doctor', ['setisSubmintflag','setIsSubmint', 'setLoading']),
			...Vuex.mapActions('supervisor', ['GetRegionAVGScore', 'GetHospitalAVGScore', 'GetHospitalUnqualifiedReport']),
			
			//日期选择
			defaultGetDate() {
				this.setDate.enddt = this.slider.marks[this.slider.value[1]]
				this.setDate.startdt = this.slider.marks[this.slider.value[0]]
			},
			//默认加载
			defaultGet() {
				this.defaultGetDate()
				if (this.trigger.regionsData) {
					this.GetRegionAVGScore();
				} else {
					if (this.HospitalAVGScoreBtn.average) {
						this.GetHospitalAVGScore();
					}
					if (this.HospitalAVGScoreBtn.deduct) {
						this.GetHospitalUnqualifiedReport();
					}

				}
			},
		}

	}
</script>

<style>

</style>
